import { useEffect } from 'react';

import * as Sentry from '@sentry/react';

import useAuthStore from '@/stores/auth';

export const useSentryTagsSetter = () => {
  const currentUser = useAuthStore(({ currentUser }) => currentUser);

  useEffect(() => {
    if (!currentUser) {
      return;
    }

    Sentry.setUser({
      email: currentUser?.email
    });
  }, [currentUser]);
};
